import { firstAndLastStroke as dto } from '@haohan/game-dto';
import { EngineAPI } from '../engine-api';
import { CreateGameInDTO } from '@haohan/game-dto';


export class FirstAndLastStrokeApi extends EngineAPI<
    dto.CreateGameInDTO,
    dto.ProcessActionInDTO,
    dto.ProcessActionOutDTO
> {
    dto: { CreateGameInDTO: { new(): CreateGameInDTO; }; } = {
        CreateGameInDTO: dto.CreateGameInDTO
    };
}